<template>
    <div class="all">
        <div class="screen">
            <h2 class="ovhidden" v-html="title"></h2>
        </div>
        <div class="warp mt20">
            <div class="warp-header">
                <div class="firle clearfix">
                    <div class="fl">
                        <label class="checkbox-box tion">
                            <label class="checkbox-warp fl" :class="uuids.length === pageUuid.length && uuids.length > 0 ? 'curr' : ''">
                                <input class="checkbox" name="selectAll" :checked="uuids.length === pageUuid.length && uuids.length > 0 ? true : false" @click="checkAll($event)" type="checkbox" value="0">
                                <i class="icons checkbox-icon"></i>
                            </label>
                            全选
                        </label>
                        <span class="checkbox-box cp tion" @click="downLoad(1);" title="下载当前所选数据">批量下载</span>
                        <span class="checkbox-box cp tion" @click="downLoad(5);" title="下载当前方案的所有数据">全部下载</span>
                    </div>
                </div>
            </div>
            <div class="warp-body clearfix">
                <div class="no-data" v-if="nodata"><img :src="$parent.baseUrl+'/static/images/no_data.png'" class="img"/><span class="text">没有数据哦...</span></div>
                <ul class="article-list">
                    <li v-for="(item,index) in newsList" :key="index">
                        <div class="article-left fl">
                            <label class="checkbox-warp" :class="uuids.indexOf(item.newsId) != -1 ? 'curr' : ''">
                                <input class="checkbox" v-model="uuids" name="chooseInfo" type="checkbox" :value="item.newsId">
                                <i class="icons checkbox-icon"></i>
                            </label>     
                        </div> 
                        <div class="article-mid qwjs">
                            <router-link class="color-3d3d4c" target="_blank" :to="{path:''+$baseUrl+'/fullTextDetail',query: {id:item.newsId,keywords:keywords}}">
                                <h2 class="article-title ovhidden" :title="item.originNewsTitle"><span class="tag" :class="attributeType[item.newsEmotion]">{{item.newsEmotion}}</span><span v-html="item.newsTitle"></span></h2>
                                <p class="ovhidden2 color-8a8a99" :title="item.originNewsTitle" v-html="item.newsDigest"></p>
                            </router-link>
                            <p class="ziduan color-8a8a99 mt10">
                                <span>时间：{{item.newsPosttime}}</span>
                                <!-- <span>相似文章：<router-link class="color-blue" target="_blank" :to="{path:''+$parent.baseUrl+'/similarArticles',query: {id:item.newsId}}" :class="item.simNum === '' ? 'load-sm' : ''">{{item.simNum}}</router-link></span> -->
                                <span>发布平台：<i class="icons sm-icon" :class="icons[item.platform]"></i>{{item.platformName}}</span>
                                <span>发布人：{{item.mediaName}}</span>
                                <span v-if="item.mediaProvince != ''">发布地区：{{item.mediaProvince}}</span>
                                <span v-if="item.newsContentIpLocation != ''">IP属地：{{item.newsContentIpLocation}}</span>
                                <span>分析词：<i :class="item.keywords == '' ? 'load-sm' : ''"></i>{{item.keywords}}</span>
                                <!-- <span v-if="item.mediaLevel != ''">媒体等级：{{item.mediaLevel}}</span> -->
                            </p>
                        </div> 
                    </li>
                </ul>
                <!-- 分页 -->
                <page class="mt20" v-if="totalCount != ''" :currentPage.sync="page" :limit.sync="limit" :totalCount="totalCount" @turn="getTableData"></page>
            </div>
        </div>
        <!-- 下载选项 -->
        <Dialog ref="downloadOption" title="下载字段自定义选择" btnText="下载" :callback="enterOption" type="normal" width="600">
            <div slot="mdBox">
                <div class="checkbox-group nolike clearfix">
                    <h4 v-if="downloadTips != ''">tips:<span class="color-red">{{downloadTips}}</span></h4>
                    <label class="checkbox-box">
                        <label class="checkbox-warp fl" :class="selectOptionValue.length === $parent.selectOption.length ? 'curr' : ''"><input name="" :checked="selectOptionValue.length === $parent.selectOption.length ? true : false" type="checkbox" @click="optionCheckAll($event);" value="" class="checkbox"> <i class="icons checkbox-icon"></i></label>
                        <div class="hidden ac">全选<span class="color-red">（为保证您的下载速度，请尽可能筛选必要的下载字段）</span></div>
                    </label>
                </div>
                <div class="checkbox-group nolike clearfix">
                    <label class="checkbox-box" v-for="(item,index) in $parent.selectOption" :key="index">
                        <label class="checkbox-warp fl" :class="selectOptionValue.indexOf(item.type) != -1 ? 'curr' : ''"><input name="" v-model="selectOptionValue" type="checkbox" :value="item.type" class="checkbox"> <i class="icons checkbox-icon"></i></label>
                        <div class="hidden ac">{{item.name}}</div>
                    </label>
                </div>
            </div>
        </Dialog>
        <!-- 下载提示 -->
        <!-- <Dialog ref="downloadModal" :callback="enterDownload" type="confirm">
            <div slot="mdBox">
                <p class="ac">是否确认下载</p>
            </div>
        </Dialog> -->
	</div>
</template>
<script>
import Dialog from '../../components/dialog.vue'
import VueDatepickerLocal from 'vue-datepicker-local'
import city from '../../components/city.vue';
import page from '../../components/page.vue';
export default {
    components:{VueDatepickerLocal,city,page,Dialog},
    data() {
        const min = ''
        const max = ''
        return {
            attributeType:{
                '正面':'tag-blue',
                '中性':'tag-orange',
                '负面':'tag-red',
            },//属性对应的class样式
            icons:{
                'wx':'wx-icon',
                'web':'web-icon1',
                'weibo':'wb-icon1',
                'app':'app-icon1',
                'bbs':'bbs-icon1',
                'journal':'bk-icon1',
                'media_toutiao':'tt-icon1',
                'media_qq':'qq-icon1',
                'media_baijia':'bj-icon1',
                'media_sohu':'sh-icon1',
                'media_wangyi':'wy-icon1',
                'media_people':'people-icon1'
            },
            downloadTips:'',//全部下载提示
            selectOptionValue:['news_title','news_digest','news_author','media_name','news_origin_author_name','media_followers_count','news_url','platform_name','news_emotion','news_content_province','news_posttime','media_province'],//已选择下载
            title:'',
            newsId:'',//新闻id
            page:1,//页码
            limit:20,//每页显示条数
			keywords:'',//关键词
            newsSimHash:'',
            totalCount:'',//总页数
            pageUuid:[],//单分页所有的uuid
            uuids:[],//选择的newsid数组
            planId:'',//方案ID
            newsList:[],//新闻列表
            watch:true,//是否监听
            downLoadType:'',//下载类型
            nodata:false//暂无数据

        }
    },
    mounted() {
        let that = this;
		that.$nextTick(() =>{
            that.newsId = that.$route.query.id;//获取当前页面url的id
			that.keywords = that.$route.query.keywords;
            that.getNewsList(0);
        })
    },
    created() {
		// 获取缓存方案数据
        this.planId = JSON.parse(sessionStorage.getItem('planStorage')).id;
    },
    methods: {
        // 获取新闻列表
        getNewsList (type) {
            let that = this;
            if(type === 0){//非翻页
                that.page = 1;
            }
			let datas = that.$route.query;//获取路由参数
            // let datas = {
            //     sid:that.planId,
            //     newsId:that.newsId,
            //     page:that.page,
            //     perpage:that.limit
            // };
			datas.sid = that.planId;//塞入方案id
			datas.page = that.page;//塞入页码
			datas.perpage = that.limit;//塞入每页个数
            datas.mediaLevel = that.$route.query.mediaLevelold==""?"":JSON.parse(that.$route.query.mediaLevelold);
            that.uuids = [];
            $(".warp .checkbox-warp").removeClass('curr');
            $(".warp input:checkbox[name='selectAll']").prop("checked",false);
            that.$parent.loadModal(true,'正在获取数据...');
            that.$api.post('monitor/search/sim-article-list', {data:datas}, r => {
                that.$parent.returnCode(r,function(){
                    that.$parent.showLoad = false;
                    let data = r.data;
                    that.title = data.newsDetail.title;
                    // that.keywords = '';
                    if(data.list.length <= 0){//没有数据
                        that.nodata = true;
                        return;
                    }else{
                         that.nodata = false;
                    }
                    that.newsList = data.list;//新闻列表赋值 
                    that.totalCount = data.total;
                    that.newsSimHash = data.newsDetail.newsSimHash;
                    let pageUuid = [];
                    for(let i of data.list){
                        pageUuid.push(i.newsId);
                    }
                    that.pageUuid = pageUuid;
                    // 调用获取分析词和相似文章
                    that.getSimilarArticle(data.list);
                });
            })
        },
        // 获取分析词和相似文章
        getSimilarArticle (data) {
            let that = this;
            let oldData = data;
            let newsIds = [];
            let postDate = [];
            for(let i of data){
                newsIds.push(i.newsId);
                postDate.push(i.newsPostdate);
            }
            that.$api.post('monitor/search/news-keyword', {postDate:postDate,newsId:newsIds,keywords:that.keywords}, r => {
                that.$parent.returnCode(r,function(){
                    let datas = r.data;
                    for(let i of data){
                        for(let j in datas){
                            if(i.newsId === j){
                                i.keywords = datas[j].keywords;
                            }
                        }
                    }
                    if(that.newsList === oldData){
                        that.newsList = data;
                    }
                });
            })
        },
        // 全选状态
        checkAll (e) {
            let that = this;
            let checked = e.target.checked;
            that.uuids = [];
            if(checked == true){
                that.uuids = that.pageUuid;//全选的时候 获取所有的uuid
            }else{
                that.uuids = [];
            }
        },
        // 下载
        downLoad (type) {
            this.$sensors.track('Clickdownload', {
                page_source:document.title
            });
            let that = this;
            that.downLoadType = type;
            that.selectOptionValue = ['news_title','news_digest','news_author','media_name','news_origin_author_name','media_followers_count','news_url','platform_name','news_emotion','news_content_province','news_posttime','media_province'];
            let uuid = '';//全部下载为空
            if(type === 1){//选择下载
                uuid = that.uuids;
                that.downloadTips = '';
                if(uuid.length <= 0){
                    that.$utils.alertText('请选择需要下载的新闻');
                    return;
                }
                that.$refs.downloadOption.showMaskFun();
            }else{
                if(that.newsList.length <= 0){
                    that.$utils.alertText('暂无可下载数据');
                    return;
                }
				let data = JSON.parse(JSON.stringify(that.$route.query));//获取路由参数
				data.uuid = uuid;//塞入方案id
				data.field = that.selectOptionValue;//塞入方案id
				data.simHash = that.newsSimHash;//塞入方案id
				delete data.newsId;
                // let data = {
                //     uuid:uuid,
                //     mediaLevel:'',
                //     platformType:'',
                //     startDate:'',
                //     endDate:'',
                //     field:that.selectOptionValue,
                //     province:'',
                //     simHash:that.newsSimHash,//全部下载时需要
                //     city:'',
                //     perpage:that.limit,
                //     emotion:'',
                //     match:'1',
                //     sort:'desc',
                //     keywords:''
                // };
                that.$parent.loadModal(true,'正在获取数据...');
                that.$api.post('monitor/search/download-before', {type:type,sid:that.planId,data:data}, r => {
                    that.$parent.returnCode(r,function(){
                        that.$parent.showLoad = false;
                        that.downloadTips = r.msg;
                        that.$refs.downloadOption.showMaskFun();
                    });
                })
            }
        },
        // 确定下载字段
        enterOption () {
            let that = this;
            if(that.selectOptionValue.length <= 0){
                that.$utils.alertText('请选择需要下载的字段');
                return;
            }
            let uuid = '';//全部下载为空
            let type = that.downLoadType;
            if(type === 1){//选择下载
                uuid = that.uuids;
            }
			let data = that.$route.query;//获取路由参数
			data.uuid = uuid;//塞入方案id
			data.field = that.selectOptionValue;//塞入方案id
			data.simHash = that.newsSimHash;//塞入方案id
			delete data.newsId;
            // let data = {
            //     uuid:uuid,
            //     mediaLevel:'',
            //     platformType:'',
            //     startDate:'',
            //     endDate:'',
            //     field:that.selectOptionValue,
            //     province:'',
            //     simHash:that.newsSimHash,//全部下载时需要
            //     city:'',
            //     perpage:that.limit,
            //     emotion:'',
            //     match:'1',
            //     sort:'desc',
            //     keywords:''
            // };
            that.$parent.loadModal(true,'正在提交数据...');
            that.$api.post('monitor/search/download', {type:type,sid:that.planId,data:data}, r => {
                that.$parent.returnCode(r,function(){
                    that.$parent.showLoad = false;
                    that.selectOptionValue = [];
                    that.$sensors.track('download', {
                        is_success:true,
                        page_source:document.title,
                        fail_reason:''
                    });
                    that.$refs.downloadOption.closeMask();
                    that.$parent.alertTips('已添加到我的下载列表');
                });
            })
        },
        // 下载字段全选
        optionCheckAll (e) {
            let that = this;
            that.selectOptionValue = [];
            let checked = e.target.checked;
            if(checked == true){
                let selectOption = that.$parent.selectOption;
                for(let i of selectOption){
                    that.selectOptionValue.push(i.type);
                }
            }else{
                that.selectOptionValue = [];
            }
            
        },
        // 翻页
        getTableData () {
            let that = this;
            that.getNewsList(1);
        }
    },
    watch: {
        platformType(){
            let that = this;
            let len = that.platformType.length;
            if(that.platformType[len-1] === '' && len){
                that.platformType = [];
            }
            if(that.watch == true){
                that.getNewsList(0);
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/page/productCenter/fullSimilarArticles.vue